import type {Criterion, CriterionField, ICriterionFactory} from '../criteria.types';
import BetweenCriterion from '../criterions/between.criterion';
import EqCriterion from '../criterions/eq.criterion';
import InCriterion from '../criterions/in.criterion';
import TextCriterion from '../criterions/text.criterion';

export default class CriterionFactory implements ICriterionFactory<Criterion> {

    public createTextCriterion(field: CriterionField, matcher?, startsWith?): TextCriterion {
        return new TextCriterion(field, matcher, startsWith);
    }

    public createBetweenCriterion(field: CriterionField, matcher?): BetweenCriterion {
        return new BetweenCriterion(field, matcher);
    }

    public createEqCriterion(field: CriterionField, matcher?): EqCriterion {
        return new EqCriterion(field, matcher);
    }

    public createInCriterion(field: CriterionField, matcher?): InCriterion {
        return new InCriterion(field, matcher);
    }
}
